/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Already_Have_AccountInputs */

const en_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const fr_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà un compte ?`)
};

const de_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie haben bereits ein Konto?`)
};

const it_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai già un account?`)
};

const ru_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас уже есть аккаунт?`)
};

const es_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Ya tienes una cuenta?`)
};

const zh_cn2_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已有账号？`)
};

const ja_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちですか?`)
};

const hi_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आपके पास पहले से एक खाता मौजूद है?`)
};

const pt_pt2_login_already_have_account = /** @type {(inputs: Login_Already_Have_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Já tem uma conta?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Login_Already_Have_AccountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_already_have_account = /** @type {((inputs?: Login_Already_Have_AccountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Already_Have_AccountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_already_have_account(inputs)
	if (locale === "de") return de_login_already_have_account(inputs)
	if (locale === "it") return it_login_already_have_account(inputs)
	if (locale === "ru") return ru_login_already_have_account(inputs)
	if (locale === "es") return es_login_already_have_account(inputs)
	if (locale === "zh-CN") return zh_cn2_login_already_have_account(inputs)
	if (locale === "ja") return ja_login_already_have_account(inputs)
	if (locale === "hi") return hi_login_already_have_account(inputs)
	if (locale === "pt-PT") return pt_pt2_login_already_have_account(inputs)
	return en_login_already_have_account(inputs)
});